import React from "react";
import type { UserListItem } from "../../../types/userInvite";
import { UserStatusBadge } from "./UserStatusBadge";
import { UserRowActions } from "./UserRowActions";

interface UserListRowProps {
  user: UserListItem;
  onDeactivate: (user: UserListItem) => void;
  onEdit: (user: UserListItem) => void;
}

const formatLastActivity = (user: UserListItem): string => {
  const date = user.registered_at ?? user.invited_at;
  if (!date) {
    return "—";
  }
  return new Date(date).toLocaleDateString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const UserListRow: React.FC<UserListRowProps> = ({
  user,
  onEdit,
  onDeactivate,
}) => (
  <tr
    className="cursor-pointer border-b border-gray-200 hover:bg-gray-50"
    onClick={() => onEdit(user)}
    data-testid={`user-row-${user.id}`}
  >
    <td className="px-4 py-3 text-sm text-gray-900">
      {user.first_name} {user.last_name}
    </td>
    <td className="px-4 py-3 text-sm text-gray-500">{user.email}</td>
    <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-500">
      {user.role?.display_name ?? user.role?.name ?? "—"}
    </td>
    <td className="whitespace-nowrap px-4 py-3 text-sm">
      <UserStatusBadge status={user.status} inviteExpiresAt={user.invite_expires_at} />
    </td>
    <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-500">
      {formatLastActivity(user)}
    </td>
    <td className="whitespace-nowrap px-4 py-3 text-right text-sm">
      <UserRowActions
        user={user}
        onEdit={onEdit}
        onDeactivate={onDeactivate}
      />
    </td>
  </tr>
);
